import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import Logo from "../Images/Qualified-Stucco-logo.png";
import "../Styles/Footer.css";

function Footer() {
  return (
    <div className="footer-section">
      {/* Top row - Logo + Social */}
      <div className="footer-top">
        <div className="footer-top-left">
          <img src={Logo} alt="Qualified Stucco" />
        </div>
        <div className="footer-top-right">
          <a href="https://www.instagram.com/qualifiedstuccodrywall/" target="_blank" rel="noopener noreferrer" className="ft-social-btn" aria-label="Instagram">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 448 512" fill="currentColor">
              <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/>
            </svg>
          </a>
          <a href="https://www.facebook.com/QualifiedStuccoDrywall/" target="_blank" rel="noopener noreferrer" className="ft-social-btn" aria-label="Facebook">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 320 512" fill="currentColor">
              <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"/>
            </svg>
          </a>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="footer-container">
        <div className="ft-info">
          <p className="ft-description">
            Your trusted partner for stucco, drywall, and painting solutions.
            Over 15 years of experience delivering quality craftsmanship for
            residential and commercial properties.
          </p>
          <div className="ft-address">
            <FontAwesomeIcon icon={faLocationDot} className="ft-address-icon" />
            <span>5218 Broward St, Naples, FL 34112</span>
          </div>
        </div>

        <div className="ft-list">
          <p className="ft-list-title">Services</p>
          <ul className="ft-list-items">
            <li><Link to="/services/drywall-painting">Drywall Painting</Link></li>
            <li><Link to="/services/demolition-repair">Demolition Repair</Link></li>
            <li><Link to="/services/popcorn-removal">Popcorn Removal</Link></li>
          </ul>
        </div>

        <div className="ft-list">
          <p className="ft-list-title">Company</p>
          <ul className="ft-list-items">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact-us">Contact</Link></li>
          </ul>
        </div>

        <div className="ft-list">
          <p className="ft-list-title">Get In Touch</p>
          <ul className="ft-list-items">
            <li>
              <a href="mailto:info@qualifiedstuccodrywall.com">info@qualifiedstuccodrywall.com</a>
            </li>
            <li><a href="tel:+12396012421">+1 239-601-2421</a></li>
            <li><span>Mon - Fri: 09:00 - 19:00</span></li>
            <li><span>Sat - Sun: 10:00 - 14:00</span></li>
          </ul>
        </div>
      </div>

      <div className="ft-copyright">
        <p>© 2026 Qualified Stucco. All rights reserved. Design by <a href="https://xendek.com" target="_blank" rel="noopener noreferrer" className="ft-credit-link">Xendek</a></p>
      </div>
    </div>
  );
}

export default Footer;
